import { InfoModal } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Button, SxProps, Theme, Typography } from '@mui/material';

const STRINGS = appStrings.modules.satActBooster.noScoreModal;

type NoScoreModalProps = Readonly<{
  open: boolean;
  onClose: () => void;
}>;

export const NoScoreModal = ({ open, onClose }: NoScoreModalProps) => (
  <InfoModal
    open={open}
    onClose={onClose}
    width="xs"
    icon="File02"
    headerContent={
      <Box sx={headerSx}>
        <Typography variant="text-lg-semibold" sx={titleSx}>
          {STRINGS.title}
        </Typography>
        <Typography variant="text-sm-regular" sx={subtitleSx}>
          {STRINGS.body}
        </Typography>
      </Box>
    }
    bodyContent={
      <Box sx={bodySx}>
        <Button
          id="booster-no-score-modal-dismiss-btn"
          variant="contained"
          size="lg"
          hierarchy="Primary"
          fullWidth
          onClick={onClose}
        >
          {STRINGS.dismiss}
        </Button>
      </Box>
    }
  />
);

const headerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xs'],
  px: backrs.spacing['spacing-xl'],
});

const bodySx: SxProps<Theme> = ({ backrs }) => ({
  px: backrs.spacing['spacing-xl'],
  pb: backrs.spacing['spacing-md'],
});

const titleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
});

const subtitleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});
